import gql from 'graphql-tag'

const mutation = gql`
mutation updateDepartment($id: ID!, $fields: DepartmentInput!) {
	cashAssist {
		updateDepartment(id: $id, fields: $fields) {
			id
	    mod_ver
	    name
		}
	}
}
`
export default mutation
